var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcContest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1031 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M775 466c83 0 145-29 185-87 40-59 57-144 51-254-1-13-6-23-15-33-8-9-18-14-31-16H776V25c0-4-1-8-3-10-3-3-6-5-10-5H261c-4 0-7 1-10 4-2 2-3 6-3 10v52H58c-13 1-24 6-33 16s-14 20-15 33C4 235 21 320 61 379c40 58 102 87 185 87 4 39 14 76 33 109s44 62 75 85c31 22 66 37 105 45v191H216c-12 3-23 9-31 20-8 10-12 22-11 35s5 24 14 33 20 14 33 16h604c13-2 23-9 30-20 8-10 12-21 11-34 0-13-4-24-13-33-10-10-21-16-34-17H564V705c38-8 73-23 104-45 30-23 55-52 73-85 19-33 31-70 34-109zm0-286h134v6c-2 59-13 103-34 131-20 29-50 44-90 45h-10V180zM248 362h-9c-41-1-72-16-93-45-20-28-30-72-31-131v-6h133v182z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContest);
export default __webpack_public_path__ + "static/media/ic_contest.5d6f416bde67e06f292890ded03d267f.svg";
export { ForwardRef as ReactComponent };